// extracted by mini-css-extract-plugin
var _1 = "Switch-modulebounding__rh1a5";
var _2 = "Switch-modulechecked__o9lQH";
var _3 = "Switch-moduledisabled__Npng8";
var _4 = "Switch-moduleerror__PjwhB";
var _5 = "Switch-moduleinput__wiiOG";
var _6 = "Switch-moduleswitch__EOlJ6";
export { _1 as "bounding", _2 as "checked", _3 as "disabled", _4 as "error", _5 as "input", _6 as "switch" }
